import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import Layout, { IProps as LayoutProps } from './Layout'

import { State } from '../../model'
import * as actions from '../../model/projects/actions'
import {
  Project,
  UnsavedProjectType,
  isSavedProject,
} from '../../interfaces/entities/project'
import { ProjectsFilter } from '../../interfaces/services/projects'
import { IStringAnyMap } from '../../types/map'
import { Ordering } from '../../interfaces/pages/projects'
import { PageSize } from '../../interfaces/components/table'
import { Descriptive } from '../../interfaces/base'

import { toast } from 'react-toastify'

import DI from '../../app/di'
import { translateWithUserLocale } from '../../utils/i18n'

const { useEffect } = React

const StatefulMain = (props: LayoutProps) => {
  useEffect(() => {
    props.getProjects(null)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return <Layout {...props} />
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getProjects: (filter: ProjectsFilter | null) =>
      dispatch(actions.getProjects(filter)),
    onProjectSave: (
      project: Project | UnsavedProjectType,
      meta: { created: boolean },
    ) => {
      toast.success(translateWithUserLocale('project_modal.save_success'))
      if (meta.created && isSavedProject(project)) {
        const history = DI.get('history')
        history.push(`/project/${project.id}`)
      }
      return dispatch(actions.saveProject(project))
    },
    onFilterChange: (filter: ProjectsFilter) =>
      dispatch(actions.filterUpdated(filter)),
    doProjectAction: (
      action: Descriptive,
      project: Project,
      options?: IStringAnyMap,
    ) => dispatch(actions.doProjectAction(action, project, options)),
    onCurrentPageChange: (pageNo: number) => {
      dispatch(actions.onCurrentPageChange(pageNo))
    },
    onPageSizeChange: (size: number) => {
      dispatch(actions.onPageSizeChange(size as PageSize))
    },
    onSortingChange: (ordering: Ordering) => {
      dispatch(actions.onSortingChange(ordering))
    },
  }
}

const mapStateToProps = (state: State) => {
  return { page: state.projects, user: state.user }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatefulMain)
